import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LanguageSelector from '../component/LanguageSelector';
import { useTranslation } from 'react-i18next';
import showNotification from '../component/Notification';
import baseURL from '../component/baseURL';
import { profileAvatar } from '../component/ImageList';
import Cropper from 'react-easy-crop';
import { getCroppedImg } from '../utils/cropImage';
import { ReactNotifications } from 'react-notifications-component';
export default function Profile() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [userid, setUserid] = useState("");
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);
    const [isSwitchProfileModalOpen, setIsSwitchProfileModalOpen] = useState(false);
    const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
    const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);
    const [isChangeEmailSidebarOpen, setIsChangeEmailSidebarOpen] = useState(false);
    const [isChangePasswordSidebarOpen, setIsChangePasswordSidebarOpen] = useState(false);
    const [activePanel, setActivePanel] = useState('personal-info');
    const [isMobileEditing, setIsMobileEditing] = useState(false);
    const [profileImageSrc, setProfileImageSrc] = useState(localStorage.getItem('profileImage') || '');
    const [isUploadingImage, setIsUploadingImage] = useState(false);
    const [isCropperOpen, setIsCropperOpen] = useState(false);
    const [cropperImageSrc, setCropperImageSrc] = useState('');
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [profileImage, setProfileImage] = useState("");
    const [countryName, setCountryName] = useState("");
    const [countryCode, setCountryCode] = useState("");
    const [countryNameArray, setCountryNameArray] = useState([]);
    const [stateName, setStateName] = useState("");
    const [stateNameArray, setStateNameArray] = useState([]);
    const [stateCode, setStateCode] = useState("");
    const [cityName, setCityName] = useState("");
    const [cityNameArray, setCityNameArray] = useState([]);
    const [cityCode, setCityCode] = useState("");

    const [oldPass, setOldPass] = useState("");
    const [newPass, setNewPass] = useState("");
    const [conPass, setConPass] = useState("");
    const [oldEmail, setOldEmail] = useState("");
    const [newEmail, setNewEmail] = useState("");
    const [conEmail, setConEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [isCodePopupOpen, setIsCodePopupOpen] = useState(false);
    const [agentKey, setAgentCode] = useState(['', '', '', '', '', '']);
    const [pendingNewEmail, setPendingNewEmail] = useState("");
    const codeInputRefs = useRef([]);
    const [switchAgentKey, setSwitchAgentKey] = useState(['', '', '', '', '', '']);
    const switchCodeInputRefs = useRef([]);

    // Original values for personal-info section to track changes
    const [originalFirstName, setOriginalFirstName] = useState("");
    const [originalLastName, setOriginalLastName] = useState("");
    const [originalPhone, setOriginalPhone] = useState("");
    const [originalCountryCode, setOriginalCountryCode] = useState("");
    const [originalStateCode, setOriginalStateCode] = useState("");
    const [originalCityCode, setOriginalCityCode] = useState("");
    const [isPersonalInfoChanged, setIsPersonalInfoChanged] = useState(false);



    useEffect(() => {

        const userID = localStorage.getItem('userID');
        setUserid(userID);

        fetchDetailsAPI(userID);
        fetchCountryAPI();


        // Add class to body when component mounts
        document.body.classList.add('profile-page');

        // Remove class when component unmounts
        return () => {
            document.body.classList.remove('profile-page');
        };
    }, []);

    // Check if personal-info fields have changed
    useEffect(() => {
        const hasChanged =
            firstName !== originalFirstName ||
            lastName !== originalLastName ||
            phone !== originalPhone ||
            countryCode !== originalCountryCode ||
            stateCode !== originalStateCode ||
            cityCode !== originalCityCode;

        setIsPersonalInfoChanged(hasChanged);
    }, [firstName, lastName, phone, countryCode, stateCode, cityCode, originalFirstName, originalLastName, originalPhone, originalCountryCode, originalStateCode, originalCityCode]);

    // Update country name when countryNameArray is loaded and countryCode is set
    useEffect(() => {
        if (countryCode && countryNameArray.length > 0) {
            const foundCountry = countryNameArray.find(
                (country) => codesMatch(country.code, countryCode)
            );
            if (foundCountry && foundCountry.name !== countryName) {
                setCountryName(foundCountry.name);
            }
        }
    }, [countryNameArray, countryCode]);

    // Fetch states when countryCode is set from API or changed by user
    useEffect(() => {
        if (countryCode) {
            fetchStateAPI(countryCode);
        }
    }, [countryCode]);

    // Update state name when stateNameArray is loaded and stateCode is set
    useEffect(() => {
        if (stateCode && stateNameArray.length > 0) {
            const foundState = stateNameArray.find(
                (state) => codesMatch(getStateCode(state), stateCode)
            );
            if (foundState) {
                const stateLabel = getStateName(foundState);
                if (stateLabel && stateLabel !== stateName) {
                    setStateName(stateLabel);
                }
            }
        }
    }, [stateNameArray, stateCode]);

    // Fetch cities when stateCode is set from API or changed by user
    useEffect(() => {
        if (stateCode && countryCode) {
            fetchCityAPI(stateCode);
        }
    }, [stateCode, countryCode]);

    // Update city name when cityNameArray is loaded and cityCode is set
    useEffect(() => {
        if (cityCode && cityNameArray.length > 0) {
            const foundCity = cityNameArray.find(
                (city) => codesMatch(getCityCode(city), cityCode)
            );
            if (foundCity) {
                const cityLabel = getCityName(foundCity);
                if (cityLabel && cityLabel !== cityName) {
                    setCityName(cityLabel);
                }
            }
        }
    }, [cityNameArray, cityCode]);

    const openEditModal = () => {
        setIsEditModalOpen(true);

    };

    const closeEditModal = () => {
        setIsEditModalOpen(false);
    };

    const openLanguageModal = () => {
        setIsLanguageModalOpen(true);
    };

    const closeLanguageModal = () => {
        setIsLanguageModalOpen(false);
    };

    const openSwitchProfileModal = () => {
        setIsSwitchProfileModalOpen(true);
        // Reset switch agent key when opening
        setSwitchAgentKey(['', '', '', '', '', '']);
        // Focus first input after modal opens
        setTimeout(() => {
            if (switchCodeInputRefs.current[0]) {
                switchCodeInputRefs.current[0].focus();
            }
        }, 100);
    };

    const closeSwitchProfileModal = () => {
        setIsSwitchProfileModalOpen(false);
        // Reset switch agent key when closing
        setSwitchAgentKey(['', '', '', '', '', '']);
    };

    const openLogoutModal = () => {
        setIsLogoutModalOpen(true);
    };

    const closeLogoutModal = () => {
        setIsLogoutModalOpen(false);
    };

    const openChangePasswordModal = () => {
        setIsChangePasswordModalOpen(true);
    };

    const closeChangePasswordModal = () => {
        setIsChangePasswordModalOpen(false);
        // Reset password fields
        setOldPass('');
        setNewPass('');
        setConPass('');
    };

    const handleChangePasswordConfirm = () => {
        closeChangePasswordModal();
        changePassAPI(oldPass, newPass, conPass);
    };

    const openChangeEmailSidebar = () => {
        setIsChangeEmailSidebarOpen(true);
    };

    const closeChangeEmailSidebar = () => {
        setIsChangeEmailSidebarOpen(false);
    };

    const openChangePasswordSidebar = () => {
        setIsChangePasswordSidebarOpen(true);
    };

    const closeChangePasswordSidebar = () => {
        setIsChangePasswordSidebarOpen(false);
    };

    const handleMobileEditToggle = () => {
        setIsMobileEditing((prev) => !prev);
        if (isMobileEditing) {
            updateProfileAPI();
        }

    };

    const handleMobileDetailChange = (field, value) => {
        setMobileProfileDetails((prev) => ({
            ...prev,
            [field]: value
        }));
    };
    const profileImageInputRef = useRef(null);

    useEffect(() => {
        const handleProfileDataUpdate = () => {
            setProfileImageSrc(localStorage.getItem('profileImage') || '');
        };
        window.addEventListener('profileDataUpdated', handleProfileDataUpdate);
        return () => window.removeEventListener('profileDataUpdated', handleProfileDataUpdate);
    }, []);

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('userID');
        localStorage.removeItem('agentKey');
        navigate('/');
        window.location.reload();
    };

    const handleAvatarEditClick = () => {
        if (isUploadingImage) {
            return;
        }
        profileImageInputRef.current?.click();
    };

    // Handle input changes for form data
    const handleInputChange = (field, value) => {
        switch (field) {
            case 'country':
                setCountryName(value);
                break;
            case 'state':
                setStateName(value);
                break;
            case 'city':
                setCityName(value);
                break;
            default:
                break;
        }
    };

    const handleProfileImageChange = (event) => {
        const file = event.target.files?.[0];
        if (!file) {
            return;
        }

        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg'];
        if (!allowedTypes.includes(file.type)) {
            showNotification('Error', 'Please select a JPG, JPEG, PNG, or WEBP image', 'danger');
            event.target.value = '';
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            const fullDataUrl = reader.result;
            if (typeof fullDataUrl !== 'string') {
                showNotification('Error', 'Unable to read the selected image', 'danger');
                return;
            }
            // Open cropper modal with the image
            setCropperImageSrc(fullDataUrl);
            setIsCropperOpen(true);
            setCrop({ x: 0, y: 0 });
            setZoom(1);
        };
        reader.readAsDataURL(file);
        event.target.value = '';
    };

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const handleCropSave = async () => {
        if (!croppedAreaPixels || !cropperImageSrc) {
            return;
        }

        try {
            const croppedBase64 = await getCroppedImg(cropperImageSrc, croppedAreaPixels);
            setIsCropperOpen(false);
            updateProfileImage(croppedBase64);
        } catch (error) {
            console.error('Error cropping image:', error);
            showNotification('Error', 'Failed to crop image', 'danger');
        }
    };

    const handleCropCancel = () => {
        setIsCropperOpen(false);
        setCropperImageSrc('');
        setCrop({ x: 0, y: 0 });
        setZoom(1);
        setCroppedAreaPixels(null);
    };


    function fetchDetailsAPI(userID) {
        // console.log('USER ID ============== ' + this.state.userID)
        // const { navigate } = this.props.navigation;
        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
        fetch(baseURL.URL + '/consumers/get_consumer_details', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                const result = responseJson
                if (responseJson.server.code === 200) {
                    const fname = responseJson.response.fname || '';
                    const lname = responseJson.response.lname || '';
                    const phoneValue = responseJson.response.phone || '';
                    const countryCodeValue = responseJson.response.country || '';
                    const stateCodeValue = responseJson.response.state || '';
                    const cityCodeValue = responseJson.response.city || '';

                    setFirstName(fname);
                    setLastName(lname);
                    setEmail(responseJson.response.email);
                    setPhone(phoneValue);

                    // Store original values for change detection
                    setOriginalFirstName(fname);
                    setOriginalLastName(lname);
                    setOriginalPhone(phoneValue);
                    setOriginalCountryCode(countryCodeValue);
                    setOriginalStateCode(stateCodeValue);
                    setOriginalCityCode(cityCodeValue);

                    const fetchedProfileImage = responseJson.response.picture || '';
                    setProfileImage(fetchedProfileImage);
                    if (fetchedProfileImage) {
                        setProfileImageSrc(fetchedProfileImage);
                        localStorage.setItem('profileImage', fetchedProfileImage);
                    }

                    setCountryName(responseJson.response.country_name);
                    setStateName(responseJson.response.state_name);
                    setCityName(responseJson.response.city_name);
                    console.log('countryName', responseJson.response.country_name);
                    console.log('stateName', responseJson.response.state_name);
                    console.log('cityName', responseJson.response.city_name);

                    // Set country, state, city codes
                    setCountryCode(countryCodeValue);
                    setStateCode(stateCodeValue);
                    setCityCode(cityCodeValue);
                    console.log('countryCode', countryCodeValue);
                    console.log('stateCode', stateCodeValue);
                    console.log('cityCode', cityCodeValue);
                }
                else {
                    showNotification('Error', responseJson.server.message, 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong while fetching details', 'danger');
            });
    }

    const updateProfileImage = (profileImageBase64) => {
        const userID = localStorage.getItem('userID');

        if (!userID) {
            showNotification('Error', 'Session expired. Please login again.', 'danger');
            navigate('/');
            return;
        }

        setIsUploadingImage(true);
        const formdata = new FormData();
        formdata.append('user_id', userID);
        formdata.append('key', '81dc9bdb52d04dc20036dbd8313ed055');
        // Send full data URL format: data:image/jpeg;base64,<base64string>
        formdata.append('profile_image', profileImageBase64);

        fetch(baseURL.URL + '/consumers/change_profile_pic', {
            method: 'POST',
            body: formdata
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log('Image upload response:', responseJson);

                // Check multiple possible response structures
                const serverCode = responseJson.server?.code || responseJson.code;
                const resultCode = responseJson.server?.result_code || responseJson.result_code;
                const apiResponse = responseJson.response || responseJson.server?.response || responseJson;

                // Check if upload was successful (code 200 or result_code 200)
                if (serverCode === 200 || resultCode === 200) {
                    const apiImage = apiResponse?.profile_image || apiResponse?.picture || apiResponse?.image;

                    if (apiImage) {
                        // Add timestamp to prevent caching
                        const imageWithTimestamp = apiImage + (apiImage.includes('?') ? '&' : '?') + 't=' + Date.now();
                        // Save to localStorage for Profile page
                        localStorage.setItem('profileImage', apiImage);
                        // Also save to consumerProfileImage for Header component
                        localStorage.setItem('consumerProfileImage', apiImage);
                        setProfileImageSrc(imageWithTimestamp);
                        setProfileImage(imageWithTimestamp);
                        // Dispatch event to update Header component
                        window.dispatchEvent(new Event('profileDataUpdated'));
                        showNotification('Success', 'Image upload successful', 'success');
                    } else {
                        console.warn('Image URL not found in response:', apiResponse);
                        showNotification('Error', 'Image uploaded but URL not received', 'danger');
                    }
                } else {
                    const errorMessage = responseJson.server?.message || responseJson.message || 'Unable to update profile image';
                    console.error('Upload failed:', responseJson);
                    showNotification('Error', errorMessage, 'danger');
                }
            })
            .catch((error) => {
                console.error('Image upload error:', error);
                showNotification('Error', 'Something went wrong while uploading image', 'danger');
            })
            .finally(() => setIsUploadingImage(false));
    };

    function updateProfileAPI() {
        // const { navigate } = this.props.navigation;
        if (phone != '') {
            //   this.setState({ editMode: false })
            let formdata = new FormData();
            formdata.append("user_id", userid)
            formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
            formdata.append("fname", firstName)
            formdata.append("lname", lastName)
            formdata.append("phone", phone)
            formdata.append("state", stateCode)
            formdata.append("city", cityCode)
            formdata.append("country", countryCode)
            formdata.append("state_name", stateName)
            formdata.append("city_name", cityName)
            formdata.append("country_name", countryName)
            fetch(baseURL.URL + '/consumers/change', {
                method: 'POST',
                body: formdata
            }).then((response) => response.json())
                .then((responseJson) => {
                    const result = responseJson
                    console.log('result')
                    console.log(result)
                    if (responseJson.server.code === 200) {
                        // this.setState({ jsonResult: responseJson.response })
                        // this.setLang(this.state.selectedLangShort)
                        showNotification('Success', 'Profile updated successfully', 'success');
                        // Update original values to current values so button becomes disabled
                        setOriginalFirstName(firstName);
                        setOriginalLastName(lastName);
                        setOriginalPhone(phone);
                        setOriginalCountryCode(countryCode);
                        setOriginalStateCode(stateCode);
                        setOriginalCityCode(cityCode);
                        // console.log(responseJson.response.portfolio)
                    }
                    else {
                        showNotification('Error', responseJson.server.message || 'Unable to update profile', 'danger');
                    }
                })
                .catch((error) => {
                    console.error(error);
                    showNotification('Error', 'Something went wrong while updating profile', 'danger');
                });
        } else {
            showNotification('Error', 'Phone number is mandatory', 'danger');
        }
    }



    function changePassAPI(oldPass, newPass, conPass) {
        // console.log(this.state.userID)
        // console.log(oldpass.length + '\t' + newpass.length + '\t' + conPass.length)
        // this.setState({ isLoading: true })
        if (oldPass.length >= 6 && newPass.length >= 6 && conPass.length >= 6 && newPass === conPass) {
            let formdata = new FormData();
            formdata.append("user_id", userid)
            formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
            formdata.append("oldpassword", oldPass)
            formdata.append("newpassword", newPass)
            fetch(baseURL.URL + '/consumers/change_password', {
                method: 'POST',
                body: formdata
            }).then((response) => response.json())
                .then((responseJson) => {
                    // this.setState({ isLoading: false })
                    console.log(responseJson)
                    if (responseJson.server.result_code === 200) {
                        // Toast.showWithGravity(responseJson.server.message, Toast.SHORT, Toast.BOTTOM)
                        // this.props.navigation.goBack();
                        showNotification('Success', responseJson.server.message, 'success');
                        localStorage.removeItem('userID');
                        localStorage.removeItem('agentKey');
                        navigate('/');
                        window.location.reload();
                    }
                    else {
                        // this.setState({ oldPass: '', newPass: '', conPass: '' })
                        console.log(responseJson.server.result_code)
                        showNotification('Error', responseJson.server.message, 'danger');
                    }
                })
                .catch((error) => {
                    // this.setState({ isLoading: false })
                    console.error(error);
                });
        }
        else {
            // this.setState({ isLoading: false })
            showNotification('Error', 'Please check the old password', 'danger');
        }
    }


    function changeEmailAPI(oldEmail, newEmail) {
        console.log('changeEmailAPI called with newEmail:', newEmail);
        if (newEmail != '' || newEmail != ' ') {
            let formdata = new FormData();
            formdata.append("user_id", userid)
            formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
            formdata.append("oldemail", oldEmail)
            formdata.append("newemail", newEmail)
            fetch(baseURL.URL + '/consumers/change_email', {
                method: 'POST',
                body: formdata
            }).then((response) => response.json())
                .then((responseJson) => {
                    const result = responseJson.response;
                    console.log(responseJson)
                    if (responseJson.server.result_code === 200) {
                        console.log('Storing newEmail in pendingNewEmail:', newEmail);
                        setPendingNewEmail(newEmail);
                        setIsCodePopupOpen(true);
                        // Focus first input when popup opens
                        setTimeout(() => {
                            if (codeInputRefs.current[0]) {
                                codeInputRefs.current[0].focus();
                            }
                        }, 100);
                    }
                    else {
                        console.log(responseJson.server.result_code)
                        showNotification('Error', responseJson.server.message, 'danger');
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
        else {
            showNotification('Error', 'Please check the new email', 'danger');
        }

    }

    function submitOTP(otp, newEmail) {
        console.log('submitOTP called with newEmail:', newEmail);
        if (newEmail != '' || newEmail != ' ') {
            let formdata = new FormData();
            formdata.append("user_id", userid)
            formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
            formdata.append("otp", otp)
            formdata.append("newemail", newEmail)
            console.log('submitOTP API call - newemail parameter:', newEmail);
            fetch(baseURL.URL + '/consumers/verify_email_otp', {
                method: 'POST',
                body: formdata
            }).then((response) => response.json())
                .then((responseJson) => {
                    console.log(responseJson);
                    const result = responseJson.response
                    if (responseJson.server.result_code === 200) {
                        showNotification('Success', responseJson.server.message, 'success');
                        setIsCodePopupOpen(false);
                        setAgentCode(['', '', '', '', '', '']);
                        setPendingNewEmail('');
                        navigate('/')
                        localStorage.removeItem('userID');
                        localStorage.removeItem('agentKey');
                        window.location.reload();
                    }
                    else {
                        console.log(responseJson.server.result_code)
                        showNotification('Error', responseJson.server.message, 'danger');
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
        else {
            showNotification('Error', 'Please check the new email', 'danger');
        }




    }

    const handleCodeChange = (index, value) => {
        // Only allow single digit
        if (value.length > 1) return;

        // Only allow numbers
        if (value && !/^\d$/.test(value)) return;

        const newCode = [...agentKey];
        newCode[index] = value;
        setAgentCode(newCode);

        // Auto-focus next input if value entered
        if (value && index < 5) {
            codeInputRefs.current[index + 1]?.focus();
        }
    };

    const handleCodeKeyDown = (index, e) => {
        // Handle backspace
        if (e.key === 'Backspace' && !agentKey[index] && index > 0) {
            codeInputRefs.current[index - 1]?.focus();
        }
    };

    const handleCodePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').trim();
        if (/^\d{6}$/.test(pastedData)) {
            const newCode = pastedData.split('').slice(0, 6);
            setAgentCode(newCode);
            // Focus last input
            codeInputRefs.current[5]?.focus();
        }
    };

    const handleSubmitCode = () => {
        const codeString = agentKey.join('');
        if (codeString.length === 6 && pendingNewEmail) {
            console.log('handleSubmitCode - OTP:', codeString, 'newEmail:', pendingNewEmail);
            submitOTP(codeString, pendingNewEmail);
        }
    };

    const handleCancelCode = () => {
        setIsCodePopupOpen(false);
        setAgentCode(['', '', '', '', '', '']);
        setPendingNewEmail('');
    };

    // Switch Profile Modal handlers
    const handleSwitchCodeChange = (index, value) => {
        // Only allow single digit
        if (value.length > 1) return;

        // Only allow numbers
        if (value && !/^\d$/.test(value)) return;

        const newCode = [...switchAgentKey];
        newCode[index] = value;
        setSwitchAgentKey(newCode);

        // Auto-focus next input if value entered
        if (value && index < 5) {
            switchCodeInputRefs.current[index + 1]?.focus();
        }
    };

    const handleSwitchCodeKeyDown = (index, e) => {
        // Handle backspace
        if (e.key === 'Backspace' && !switchAgentKey[index] && index > 0) {
            switchCodeInputRefs.current[index - 1]?.focus();
        }
    };

    const handleSwitchCodePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').trim();
        if (/^\d{6}$/.test(pastedData)) {
            const newCode = pastedData.split('').slice(0, 6);
            setSwitchAgentKey(newCode);
            // Focus last input
            switchCodeInputRefs.current[5]?.focus();
        }
    };

    const handleSwitchProfileSubmit = () => {
        const codeString = switchAgentKey.join('');
        if (codeString.length === 6) {
            addAgentCodeApi(codeString);
            closeSwitchProfileModal();
        } else {
            showNotification('Error', 'Please enter a valid 6-digit agent code', 'danger');
        }
    };




    const normalizeList = (payload) => {
        if (Array.isArray(payload)) {
            return payload;
        }
        if (payload && typeof payload === 'object') {
            return Object.values(payload);
        }
        return [];
    };

    const normalizeCodeValue = (value) => {
        if (value === null || value === undefined) {
            return '';
        }
        const str = String(value);
        const stripped = str.replace(/^0+/, '');
        return stripped === '' ? '0' : stripped;
    };

    const codesMatch = (a, b) => {
        if (!a || !b) {
            return false;
        }
        return normalizeCodeValue(a) === normalizeCodeValue(b);
    };

    const getStateCode = (state) => {
        if (!state) {
            return '';
        }
        return String(state.region_code ?? state.state_id ?? state.id ?? state.code ?? '');
    };

    const getStateName = (state) => {
        if (!state) {
            return '';
        }
        return state.region_name ?? state.state_name ?? state.name ?? '';
    };

    const getCityCode = (city) => {
        if (!city) {
            return '';
        }
        return String(city.city_id ?? city.id ?? city.code ?? '');
    };

    const getCityName = (city) => {
        if (!city) {
            return '';
        }
        return city.city_name ?? city.name ?? '';
    };

    // Calculate current profile image - will update when state changes
    const currentProfileImage = profileImageSrc || profileImage || profileAvatar;

    // API Functions
    function fetchCountryAPI() {
        console.log('Fetching countries...');
        fetch(baseURL.URL + '/address/country', { method: 'POST' })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log("Countries loaded:", responseJson.response?.countries);
                setCountryNameArray(responseJson.response?.countries || []);
            })
            .catch((error) => {
                console.error('Error fetching countries:', error);
            });
    }

    function fetchStateAPI(cCode) {
        console.log("Fetching states for country code:", cCode);
        if (cCode) {
            let formdata = new FormData();
            formdata.append("country_code", cCode);
            fetch(baseURL.URL + '/address/state', { method: 'POST', body: formdata })
                .then((response) => response.json())
                .then((responseJson) => {
                    console.log("States loaded:", responseJson.response);
                    const statesPayload = responseJson.response?.states ?? responseJson.response?.regions ?? responseJson.response;
                    setStateNameArray(normalizeList(statesPayload));
                })
                .catch((error) => {
                    console.error('Error fetching states:', error);
                });
        }
    }

    function fetchCityAPI(sCode) {
        console.log("Fetching cities for state code:", sCode, "country code:", countryCode);
        if (sCode && countryCode) {
            let formdata = new FormData();
            formdata.append("country_code", countryCode);
            formdata.append("state_id", sCode);
            fetch(baseURL.URL + '/address/city', { method: 'POST', body: formdata })
                .then((response) => response.json())
                .then((responseJson) => {
                    console.log("Cities loaded:", responseJson.response);
                    const citiesPayload = responseJson.response?.cities ?? responseJson.response;
                    setCityNameArray(normalizeList(citiesPayload));
                })
                .catch((error) => {
                    console.error('Error fetching cities:', error);
                });
        }
    }


    function addAgentCodeApi(agentKey) {

        let formdata = new FormData();
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
        formdata.append("user_id", localStorage.getItem('userID'))
        formdata.append("agent_key", agentKey)
        fetch(baseURL.URL + '/consumers/agent_details', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                console.log('ADD AGENT CODE API RESPONSE-------------------------');
                console.log(responseJson);
                if (responseJson.server.result_code === 200) {
                    // Store the new agent key and agent details
                    localStorage.setItem('agentKey', agentKey);
                    localStorage.setItem('firstName', responseJson.server.response.fname);
                    localStorage.setItem('lastName', responseJson.server.response.lname);

                    showNotification('Success', 'Profile switched successfully', 'success');

                    // Navigate to home page with new agent code
                    navigate('/home');
                }
                else if (responseJson.server.result_code === 500) {
                    //   this.startShake()
                    // Show error notification
                    showNotification('Error', responseJson.server.message, 'danger');
                }
                else {
                    //   this.startShake()
                    console.log(responseJson.server.result_code)
                    showNotification('Error', 'Something went wrong', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong', 'danger');
            });
    }


    return (
        <>
            <ReactNotifications />
            <main className="main-content">
                <div className="container">
                    {/* <!-- Mobile Profile Info Section --> */}
                    <section className="mobile-profile-info">
                        <div className="mobile-profile-header">
                            <h1 className="mobile-profile-title">{t('profileInformation')}</h1>

                            {isMobileEditing ? (
                                <button className="mobile-profile-edit-btn" id="mobileProfileEditBtn" aria-label="Edit Profile" onClick={handleMobileEditToggle}>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="fi_2874091" viewBox="0 0 32 32" width="512" height="512"><path d="M30.71,7.29l-6-6A1,1,0,0,0,24,1H4A3,3,0,0,0,1,4V28a3,3,0,0,0,3,3H28a3,3,0,0,0,3-3V8A1,1,0,0,0,30.71,7.29ZM20,3V9H12V3ZM8,29V22a1,1,0,0,1,1-1H23a1,1,0,0,1,1,1v7Zm21-1a1,1,0,0,1-1,1H26V22a3,3,0,0,0-3-3H9a3,3,0,0,0-3,3v7H4a1,1,0,0,1-1-1V4A1,1,0,0,1,4,3h6V9a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V3h1.59L29,8.41Z"></path></svg>

                                </button>) : (
                                <button className="mobile-profile-edit-btn" id="mobileProfileEditBtn" aria-label="Edit Profile" onClick={handleMobileEditToggle}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M4.76 18.81C4.76 18.81 4.84 18.81 4.87 18.81L7.8 18.54C8.21 18.5 8.59 18.32 8.88 18.03L19.94 6.96998C20.46 6.44998 20.75 5.75998 20.75 5.02998C20.75 4.29998 20.46 3.60998 19.94 3.08998L19.23 2.37998C18.19 1.33998 16.38 1.33998 15.34 2.37998L13.93 3.78998L4.29 13.43C4 13.72 3.82 14.1 3.79 14.51L3.52 17.44C3.49 17.81 3.62 18.17 3.88 18.44C4.12 18.68 4.43 18.81 4.76 18.81ZM17.29 3.06998C17.61 3.06998 17.93 3.18998 18.17 3.43998L18.88 4.14998C19.12 4.38998 19.25 4.69998 19.25 5.02998C19.25 5.35998 19.12 5.67998 18.88 5.90998L18 6.78998L15.53 4.31998L16.41 3.43998C16.65 3.19998 16.97 3.06998 17.29 3.06998ZM5.28 14.65C5.28 14.59 5.31 14.54 5.35 14.5L14.46 5.37998L16.93 7.84998L7.82 16.96C7.82 16.96 7.72 17.03 7.67 17.03L5.04 17.27L5.28 14.64V14.65ZM22.75 22C22.75 22.41 22.41 22.75 22 22.75H2C1.59 22.75 1.25 22.41 1.25 22C1.25 21.59 1.59 21.25 2 21.25H22C22.41 21.25 22.75 21.59 22.75 22Z" fill="#1C4CAF" />
                                    </svg>
                                </button>)}
                        </div>
                        <div className="mobile-profile-avatar-section">
                            <div className="mobile-profile-avatar-wrapper relative">
                                <img
                                    className="mobile-profile-avatar"
                                    src={currentProfileImage}
                                    alt="User avatar"
                                    key={profileImageSrc || profileImage || 'default'}
                                />
                                <button className="avatar-edit" id="desktopProfileEditBtn" aria-label="Edit Profile" onClick={handleAvatarEditClick} disabled={isUploadingImage}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M4.76 18.81C4.76 18.81 4.84 18.81 4.87 18.81L7.8 18.54C8.21 18.5 8.59 18.32 8.88 18.03L19.94 6.96998C20.46 6.44998 20.75 5.75998 20.75 5.02998C20.75 4.29998 20.46 3.60998 19.94 3.08998L19.23 2.37998C18.19 1.33998 16.38 1.33998 15.34 2.37998L13.93 3.78998L4.29 13.43C4 13.72 3.82 14.1 3.79 14.51L3.52 17.44C3.49 17.81 3.62 18.17 3.88 18.44C4.12 18.68 4.43 18.81 4.76 18.81ZM17.29 3.06998C17.61 3.06998 17.93 3.18998 18.17 3.43998L18.88 4.14998C19.12 4.38998 19.25 4.69998 19.25 5.02998C19.25 5.35998 19.12 5.67998 18.88 5.90998L18 6.78998L15.53 4.31998L16.41 3.43998C16.65 3.19998 16.97 3.06998 17.29 3.06998ZM5.28 14.65C5.28 14.59 5.31 14.54 5.35 14.5L14.46 5.37998L16.93 7.84998L7.82 16.96C7.82 16.96 7.72 17.03 7.67 17.03L5.04 17.27L5.28 14.64V14.65ZM22.75 22C22.75 22.41 22.41 22.75 22 22.75H2C1.59 22.75 1.25 22.41 1.25 22C1.25 21.59 1.59 21.25 2 21.25H22C22.41 21.25 22.75 21.59 22.75 22Z" fill="white" />
                                    </svg>
                                </button>
                            </div>
                            <h2 className="mobile-profile-name">{localStorage.getItem('consumerFirstName')} {localStorage.getItem('consumerLastName')}</h2>
                            <p className="mobile-profile-email">{localStorage.getItem('consumerEmail')}</p>
                            <div className="mobile-profile-icons">
                                {/* <button className="mobile-icon-btn" id="mobileLanguageBtn" aria-label="Language" onClick={openLanguageModal}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <g clip-path="url(#clip0_322_116)">
                                            <path d="M18.8801 5.38879L18.8151 5.41754C17.3576 6.06629 15.8438 6.53754 14.2913 6.84754C14.7301 8.92879 14.7288 11.0788 14.2888 13.1588C15.8413 13.4675 17.3626 13.935 18.8138 14.5813L18.8776 14.61C19.5913 13.2288 20.0001 11.6638 20.0001 10C20.0001 8.33629 19.5913 6.77129 18.8801 5.38879Z" fill="#1C4CAF" />
                                            <path d="M7.27002 14.1862C7.82252 15.945 8.73377 17.6112 9.99877 19.0837C11.2638 17.6112 12.1763 15.945 12.7275 14.1862C10.9163 13.9462 9.08127 13.9475 7.27002 14.1862Z" fill="#1C4CAF" />
                                            <path d="M13.0525 7.04248C12.0475 7.18373 11.0325 7.27998 9.99999 7.27998C8.96624 7.27998 7.95124 7.18248 6.94624 7.04248C6.52499 8.99498 6.52499 11.015 6.94874 12.9675C8.97249 12.6862 11.0262 12.6862 13.05 12.9675C13.4737 11.015 13.475 8.99498 13.0525 7.04248Z" fill="#1C4CAF" />
                                            <path d="M9.99877 0.91626C8.73377 2.38876 7.82252 4.05501 7.27002 5.81501C9.08127 6.05376 10.9175 6.05376 12.7275 5.81501C12.175 4.05626 11.2638 2.38876 9.99877 0.91626Z" fill="#1C4CAF" />
                                            <path d="M10.8613 0C12.3288 1.68 13.3738 3.59625 13.9813 5.62C15.4388 5.335 16.8663 4.90125 18.2288 4.3C16.5788 1.90125 13.9163 0.2625 10.8613 0Z" fill="#1C4CAF" />
                                            <path d="M1.77002 4.3C3.13377 4.9 4.56127 5.335 6.01752 5.62C6.62502 3.59625 7.67002 1.68 9.13752 0C6.08252 0.2625 3.42127 1.90125 1.77002 4.3Z" fill="#1C4CAF" />
                                            <path d="M5.70875 6.84877C4.15625 6.53752 2.64375 6.06751 1.1875 5.41876L1.1225 5.39001C0.40875 6.77126 0 8.33626 0 10C0 11.6638 0.40875 13.2288 1.1225 14.6113L1.1875 14.5825C2.6375 13.935 4.15875 13.4675 5.71125 13.16C5.27 11.08 5.27 8.93002 5.70875 6.84877Z" fill="#1C4CAF" />
                                            <path d="M6.01752 14.3812C4.56002 14.665 3.13252 15.1 1.77002 15.7C3.42127 18.0987 6.08252 19.7375 9.13752 20C7.67002 18.32 6.62502 16.4037 6.01752 14.3812Z" fill="#1C4CAF" />
                                            <path d="M13.9813 14.38C13.3751 16.4038 12.3288 18.32 10.8613 20C13.9163 19.7375 16.5788 18.0988 18.2288 15.7C16.8663 15.0988 15.4388 14.665 13.9813 14.38Z" fill="#1C4CAF" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_322_116">
                                                <rect width="20" height="20" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </button> */}
                                <button type="button" className="mobile-icon-btn" id="mobileSwitchProfileBtn" aria-label="Switch Profile" onClick={openSwitchProfileModal}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
                                        <g clip-path="url(#clip0_322_112)">
                                            <path d="M21.3125 12.4999C20.933 12.4999 20.625 12.2199 20.625 11.8749C20.625 9.46244 18.4663 7.49994 15.8125 7.49994H9.16667V10.2083C9.16667 10.7583 8.43883 11.0366 8.00433 10.6599L2.96267 6.28494C2.827 6.16744 2.75 6.00411 2.75 5.83328C2.75 5.66244 2.827 5.49911 2.96267 5.38161L8.00433 1.00661C8.44067 0.628275 9.16667 0.909942 9.16667 1.45828V4.16661H14.8958C18.8127 4.16661 22 7.06411 22 10.6249V11.8749C22 12.2199 21.692 12.4999 21.3125 12.4999Z" fill="#1C4CAF" />
                                            <path d="M12.8333 18.5417V15.8333H7.10417C3.18725 15.8333 0 12.9358 0 9.375V8.125C0 7.78 0.308 7.5 0.6875 7.5C1.067 7.5 1.375 7.78 1.375 8.125C1.375 10.5375 3.53375 12.5 6.1875 12.5H12.8333V9.79167C12.8333 9.24417 13.5584 8.96 13.9957 9.34L19.0373 13.715C19.173 13.8325 19.25 13.9958 19.25 14.1667C19.25 14.3375 19.173 14.5008 19.0373 14.6183L13.9957 18.9933C13.5584 19.3717 12.8333 19.09 12.8333 18.5417Z" fill="#1C4CAF" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_322_112">
                                                <rect width="22" height="20" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <div className={`mobile-profile-details ${isMobileEditing ? 'edit-mode' : ''}`}>
                            <h3 className="mobile-section-title">{t('contactDetails')}</h3>
                            <div className="mobile-detail-item">
                                <label className="mobile-detail-label form-label">{t('firstName')}</label>
                                <input
                                    type="text"
                                    className="mobile-detail-value form-control"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    disabled={!isMobileEditing}
                                />
                            </div>
                            <div className="mobile-detail-item">
                                <label className="mobile-detail-label form-label">{t('lastName')}</label>
                                <input
                                    type="text"
                                    className="mobile-detail-value form-control"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    disabled={!isMobileEditing}
                                />
                            </div>
                            <div className="mobile-detail-item">
                                <label className="mobile-detail-label form-label">{t('emailId')}</label>
                                <input
                                    type="text"
                                    className="mobile-detail-value form-control"
                                    value={email}
                                    disabled={!isMobileEditing}
                                />
                            </div>
                            <div className="mobile-detail-item">
                                <label className="mobile-detail-label form-label">{t('phoneNo')}</label>
                                <input
                                    type="text"
                                    className="mobile-detail-value form-control"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    disabled={!isMobileEditing}
                                />
                            </div>

                            <h3 className="mobile-section-title">{t('addressDetails')}</h3>
                            <div className="mobile-detail-item">
                                <label htmlFor="edit-country" className='form-label mb-2'>{t('country')}</label>
                                <select
                                    name="edit-countrys"
                                    id="edit-countrys"
                                    className="form-control"
                                    value={countryCode}
                                    disabled={!isMobileEditing}
                                    onChange={(e) => {
                                        const selectedCode = e.target.value;
                                        setCountryCode(selectedCode);

                                        const selectedCountry = countryNameArray.find(
                                            (country) => country.code === selectedCode
                                        );

                                        if (selectedCountry) {
                                            setCountryName(selectedCountry.name);
                                            handleInputChange('country', selectedCountry.name);
                                        }

                                        setStateNameArray([]);
                                        setCityNameArray([]);
                                        setStateCode('');
                                        setStateName('');
                                        setCityCode('');
                                        setCityName('');

                                        setTimeout(() => {
                                            fetchStateAPI(selectedCode);
                                        }, 100);
                                    }}
                                >
                                    <option value="">Select Country</option>
                                    {countryNameArray.map((country) => (
                                        <option key={country.code} value={country.code}>
                                            {country.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mobile-detail-item">
                                <label htmlFor="edit-state" className='form-label mb-2'>{t('state')}</label>
                                <select
                                    name="edit-states"
                                    id="edit-states"
                                    className='form-control'
                                    value={stateCode}
                                    disabled={!isMobileEditing}
                                    onChange={(e) => {
                                        const selectedCode = e.target.value;
                                        setStateCode(selectedCode);

                                        const selectedState = stateNameArray.find(
                                            (states) => states.region_code === selectedCode
                                        );

                                        if (selectedState) {
                                            setStateName(selectedState.region_name);
                                            handleInputChange('state', selectedState.region_name);
                                        }

                                        setCityNameArray([]);
                                        setCityCode('');
                                        setCityName('');

                                        setTimeout(() => {
                                            fetchCityAPI(selectedCode);
                                        }, 100);
                                    }}
                                >
                                    <option value="">Select State</option>
                                    {stateNameArray.map((states) => (
                                        <option key={states.region_code} value={states.region_code}>
                                            {states.region_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mobile-detail-item">
                                <label htmlFor="edit-city" className='form-label mb-2'>{t('city')}</label>
                                <select
                                    name="edit-citys"
                                    id="edit-citys"
                                    className='form-control'
                                    value={cityCode}
                                    disabled={!isMobileEditing}
                                    onChange={(e) => {
                                        const selectedCode = e.target.value;
                                        setCityCode(selectedCode);

                                        const selectedCity = cityNameArray.find(
                                            (citys) => citys.city_id === selectedCode
                                        );

                                        if (selectedCity) {
                                            setCityName(selectedCity.city_name);
                                            handleInputChange('city', selectedCity.city_name);
                                        }
                                    }}
                                >
                                    <option value="">Select City</option>
                                    {cityNameArray.map((citys) => (
                                        <option key={citys.city_id} value={citys.city_id}>
                                            {citys.city_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="mobile-profile-actions">
                            <button type="button" className="mobile-action-link" onClick={() => openChangeEmailSidebar()} style={{ background: 'none', border: 'none', width: '100%', textAlign: 'left', cursor: 'pointer' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
                                    <path d="M21.8062 3.97351L15.134 10L21.8062 16.0266C21.9268 15.7974 22 15.544 22 15.2735V4.7266C22 4.45601 21.9268 4.20269 21.8062 3.97351Z" fill="#1C4CAF" />
                                    <path d="M20.0664 2.96875H1.93362C1.63597 2.96875 1.35732 3.03527 1.10522 3.14492L9.63293 10.8583C10.3869 11.5438 11.6131 11.5438 12.3671 10.8583L20.8948 3.14492C20.6427 3.03527 20.3641 2.96875 20.0664 2.96875Z" fill="#1C4CAF" />
                                    <path d="M0.193789 3.97351C0.0731758 4.20269 0 4.45601 0 4.7266V15.2735C0 15.5441 0.0731758 15.7974 0.193789 16.0266L6.86593 10L0.193789 3.97351Z" fill="#1C4CAF" />
                                    <path d="M14.2227 10.8286L13.2785 11.6869C12.0222 12.8291 9.97784 12.8291 8.72148 11.6869L7.77737 10.8286L1.10522 16.8551C1.35732 16.9648 1.63597 17.0313 1.93362 17.0313H20.0664C20.3641 17.0313 20.6427 16.9648 20.8948 16.8551L14.2227 10.8286Z" fill="#1C4CAF" />
                                </svg>
                                <span>{t('changeEmailId')}</span>
                            </button>
                            {/* <Link to="/push-notification" className="mobile-action-link">
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                    <path d="M15.125 19.5312C13.836 19.5312 12.7812 18.4844 12.7812 17.1875C12.7812 17.0938 12.7969 17.0078 12.8125 16.914H12.3672C11.0781 16.914 10.0234 15.8672 10.0234 14.5703C10.0234 13.8906 10.3281 13.2734 10.7969 12.8516V10.2734C10.7969 7.92189 12.2656 5.90625 14.3359 5.09372C14.7422 4.39062 15.4922 3.90625 16.3672 3.90625C16.961 3.90625 17.5078 4.1328 17.9141 4.5156C17.8515 2.87499 16.4922 1.5625 14.8359 1.5625H6.94532C5.2422 1.5625 3.85938 2.94528 3.85938 4.64845V20.3516C3.85938 22.0547 5.2422 23.4375 6.94532 23.4375H14.8359C16.539 23.4375 17.9219 22.0547 17.9219 20.3516V19.5C17.8125 19.5234 17.7031 19.5312 17.5859 19.5312H15.125ZM10.8828 4.6875H10.8906C11.3203 4.6875 11.6719 5.03907 11.6719 5.46875C11.6719 5.89843 11.3203 6.25 10.8906 6.25C10.4531 6.25 10.1016 5.89843 10.1016 5.46875C10.1016 5.03907 10.4453 4.6875 10.8828 4.6875Z" fill="#1C4CAF" />
                                    <path d="M20.3672 13.7926V10.2734C20.3672 8.33592 18.9844 6.71873 17.1485 6.35157L17.1448 6.35099V6.25C17.1448 5.81818 16.7954 5.46875 16.3636 5.46875C15.9317 5.46875 15.5823 5.81818 15.5823 6.25V6.3448C13.7483 6.70571 12.3594 8.33726 12.3594 10.2734V13.7925C11.9334 13.7991 11.5898 14.1437 11.5898 14.5714C11.5898 15.0032 11.9393 15.3526 12.3711 15.3526H20.3553C20.7871 15.3526 21.1365 15.0032 21.1365 14.5714C21.1365 14.1438 20.7931 13.7993 20.3672 13.7926Z" fill="#1C4CAF" />
                                    <path d="M17.5864 16.4062H15.1267C14.6949 16.4062 14.3455 16.7557 14.3455 17.1875C14.3455 17.6193 14.6949 17.9688 15.1267 17.9688H17.5864C18.0182 17.9688 18.3677 17.6193 18.3677 17.1875C18.3677 16.7557 18.0182 16.4062 17.5864 16.4062Z" fill="#1C4CAF" />
                                </svg>
                                <span>{t('pushNotification')}</span>
                            </Link> */}
                            <button type="button" className="mobile-action-link" onClick={() => openChangePasswordSidebar()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 20" fill="none">
                                    <path d="M10.9997 0.856201C8.22696 0.856201 5.97108 2.907 5.97108 5.42763V8.2866H5.34282C4.12955 8.2866 3.14282 9.1838 3.14282 10.2866V17.1437C3.14282 18.2465 4.12955 19.1437 5.34282 19.1437H16.6571C17.8701 19.1437 18.8571 18.2465 18.8571 17.1437V10.2866C18.8571 9.1838 17.8701 8.2866 16.6571 8.2866H16.0282V5.42763C16.0282 2.907 13.7723 0.856201 10.9997 0.856201ZM7.85679 5.42763C7.85679 3.85232 9.26681 2.57049 10.9997 2.57049C12.7325 2.57049 14.1425 3.85232 14.1425 5.42763V8.2866H7.85679V5.42763ZM7.54282 14.578C7.02105 14.578 6.59997 14.1952 6.59997 13.7209C6.59997 13.2465 7.02105 12.8637 7.54282 12.8637C8.06429 12.8637 8.48568 13.2465 8.48568 13.7209C8.48568 14.1952 8.06429 14.578 7.54282 14.578ZM11 14.578C10.4782 14.578 10.0571 14.1952 10.0571 13.7209C10.0571 13.2465 10.4782 12.8637 11 12.8637C11.5214 12.8637 11.9428 13.2465 11.9428 13.7209C11.9428 14.1952 11.5214 14.578 11 14.578ZM14.4571 14.578C13.9353 14.578 13.5143 14.1952 13.5143 13.7209C13.5143 13.2465 13.9353 12.8637 14.4571 12.8637C14.9786 12.8637 15.4 13.2465 15.4 13.7209C15.4 14.1952 14.9786 14.578 14.4571 14.578Z" fill="#1C4CAF" />
                                </svg>
                                <span>{t('changePassword')}</span>
                            </button>
                            <button type="button" className="mobile-action-link logout-btn" id="mobileLogoutBtn" onClick={() => openLogoutModal()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                    <path d="M5.71995 2.19995C3.77591 2.19995 2.19995 3.77591 2.19995 5.71995V10.12H11.5155L9.4977 8.10221C9.15406 7.75854 9.15406 7.20136 9.4977 6.85769C9.84134 6.51404 10.3986 6.51404 10.7422 6.85769L14.2616 10.3771L14.2679 10.3835C14.3495 10.4665 14.4112 10.5617 14.4532 10.6631C14.4959 10.7661 14.5196 10.879 14.5199 10.9973V11V11.0026C14.5192 11.2416 14.4232 11.4583 14.2679 11.6164L14.2616 11.6228L10.7422 15.1422C10.3986 15.4858 9.84134 15.4858 9.4977 15.1422C9.15406 14.7986 9.15406 14.2413 9.4977 13.8977L11.5155 11.88H2.19995V16.28C2.19995 18.224 3.77591 19.7999 5.71995 19.7999H16.28C18.224 19.7999 19.7999 18.224 19.7999 16.28V5.71995C19.7999 3.77591 18.224 2.19995 16.28 2.19995H5.71995Z" fill="#1C4CAF" />
                                </svg>
                                <span onClick={() => openLogoutModal()}>{t('logOut')}</span>
                            </button>
                        </div>
                    </section>

                    <section className="profile-layout">
                        <aside className="profile-sidebar">
                            <div className="profile-card">
                                <div className="profile-avatar-wrap">
                                    <img
                                        className="profile-avatar"
                                        src={currentProfileImage}
                                        alt="User avatar"
                                        key={profileImageSrc || profileImage || 'default'}
                                    />
                                    <button className="avatar-edit" id="desktopProfileEditBtn" aria-label="Edit Profile" onClick={handleAvatarEditClick} disabled={isUploadingImage}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M4.76 18.81C4.76 18.81 4.84 18.81 4.87 18.81L7.8 18.54C8.21 18.5 8.59 18.32 8.88 18.03L19.94 6.96998C20.46 6.44998 20.75 5.75998 20.75 5.02998C20.75 4.29998 20.46 3.60998 19.94 3.08998L19.23 2.37998C18.19 1.33998 16.38 1.33998 15.34 2.37998L13.93 3.78998L4.29 13.43C4 13.72 3.82 14.1 3.79 14.51L3.52 17.44C3.49 17.81 3.62 18.17 3.88 18.44C4.12 18.68 4.43 18.81 4.76 18.81ZM17.29 3.06998C17.61 3.06998 17.93 3.18998 18.17 3.43998L18.88 4.14998C19.12 4.38998 19.25 4.69998 19.25 5.02998C19.25 5.35998 19.12 5.67998 18.88 5.90998L18 6.78998L15.53 4.31998L16.41 3.43998C16.65 3.19998 16.97 3.06998 17.29 3.06998ZM5.28 14.65C5.28 14.59 5.31 14.54 5.35 14.5L14.46 5.37998L16.93 7.84998L7.82 16.96C7.82 16.96 7.72 17.03 7.67 17.03L5.04 17.27L5.28 14.64V14.65ZM22.75 22C22.75 22.41 22.41 22.75 22 22.75H2C1.59 22.75 1.25 22.41 1.25 22C1.25 21.59 1.59 21.25 2 21.25H22C22.41 21.25 22.75 21.59 22.75 22Z" fill="white" />
                                        </svg>
                                    </button>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        ref={profileImageInputRef}
                                        style={{ display: 'none' }}
                                        onChange={handleProfileImageChange}
                                    />
                                </div>
                                <h3 className="profile-name">{firstName} {lastName}</h3>
                                <p className="profile-username">{email}</p>

                                <div className="profile-card-actions">
                                    {/* <button type="button" className="profile-action-btn" id="desktopLanguageBtn" onClick={openLanguageModal}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <g clip-path="url(#clip0_322_116)">
                                                <path d="M18.8801 5.38879L18.8151 5.41754C17.3576 6.06629 15.8438 6.53754 14.2913 6.84754C14.7301 8.92879 14.7288 11.0788 14.2888 13.1588C15.8413 13.4675 17.3626 13.935 18.8138 14.5813L18.8776 14.61C19.5913 13.2288 20.0001 11.6638 20.0001 10C20.0001 8.33629 19.5913 6.77129 18.8801 5.38879Z" fill="#1C4CAF" />
                                                <path d="M7.27002 14.1862C7.82252 15.945 8.73377 17.6112 9.99877 19.0837C11.2638 17.6112 12.1763 15.945 12.7275 14.1862C10.9163 13.9462 9.08127 13.9475 7.27002 14.1862Z" fill="#1C4CAF" />
                                                <path d="M13.0525 7.04248C12.0475 7.18373 11.0325 7.27998 9.99999 7.27998C8.96624 7.27998 7.95124 7.18248 6.94624 7.04248C6.52499 8.99498 6.52499 11.015 6.94874 12.9675C8.97249 12.6862 11.0262 12.6862 13.05 12.9675C13.4737 11.015 13.475 8.99498 13.0525 7.04248Z" fill="#1C4CAF" />
                                                <path d="M9.99877 0.91626C8.73377 2.38876 7.82252 4.05501 7.27002 5.81501C9.08127 6.05376 10.9175 6.05376 12.7275 5.81501C12.175 4.05626 11.2638 2.38876 9.99877 0.91626Z" fill="#1C4CAF" />
                                                <path d="M10.8613 0C12.3288 1.68 13.3738 3.59625 13.9813 5.62C15.4388 5.335 16.8663 4.90125 18.2288 4.3C16.5788 1.90125 13.9163 0.2625 10.8613 0Z" fill="#1C4CAF" />
                                                <path d="M1.77002 4.3C3.13377 4.9 4.56127 5.335 6.01752 5.62C6.62502 3.59625 7.67002 1.68 9.13752 0C6.08252 0.2625 3.42127 1.90125 1.77002 4.3Z" fill="#1C4CAF" />
                                                <path d="M5.70875 6.84877C4.15625 6.53752 2.64375 6.06751 1.1875 5.41876L1.1225 5.39001C0.40875 6.77126 0 8.33626 0 10C0 11.6638 0.40875 13.2288 1.1225 14.6113L1.1875 14.5825C2.6375 13.935 4.15875 13.4675 5.71125 13.16C5.27 11.08 5.27 8.93002 5.70875 6.84877Z" fill="#1C4CAF" />
                                                <path d="M6.01752 14.3812C4.56002 14.665 3.13252 15.1 1.77002 15.7C3.42127 18.0987 6.08252 19.7375 9.13752 20C7.67002 18.32 6.62502 16.4037 6.01752 14.3812Z" fill="#1C4CAF" />
                                                <path d="M13.9813 14.38C13.3751 16.4038 12.3288 18.32 10.8613 20C13.9163 19.7375 16.5788 18.0988 18.2288 15.7C16.8663 15.0988 15.4388 14.665 13.9813 14.38Z" fill="#1C4CAF" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_322_116">
                                                    <rect width="20" height="20" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </button> */}
                                    <button type="button" className="profile-action-btn" id="desktopSwitchProfileBtn" onClick={openSwitchProfileModal}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
                                            <g clip-path="url(#clip0_322_112)">
                                                <path d="M21.3125 12.4999C20.933 12.4999 20.625 12.2199 20.625 11.8749C20.625 9.46244 18.4663 7.49994 15.8125 7.49994H9.16667V10.2083C9.16667 10.7583 8.43883 11.0366 8.00433 10.6599L2.96267 6.28494C2.827 6.16744 2.75 6.00411 2.75 5.83328C2.75 5.66244 2.827 5.49911 2.96267 5.38161L8.00433 1.00661C8.44067 0.628275 9.16667 0.909942 9.16667 1.45828V4.16661H14.8958C18.8127 4.16661 22 7.06411 22 10.6249V11.8749C22 12.2199 21.692 12.4999 21.3125 12.4999Z" fill="#1C4CAF" />
                                                <path d="M12.8333 18.5417V15.8333H7.10417C3.18725 15.8333 0 12.9358 0 9.375V8.125C0 7.78 0.308 7.5 0.6875 7.5C1.067 7.5 1.375 7.78 1.375 8.125C1.375 10.5375 3.53375 12.5 6.1875 12.5H12.8333V9.79167C12.8333 9.24417 13.5584 8.96 13.9957 9.34L19.0373 13.715C19.173 13.8325 19.25 13.9958 19.25 14.1667C19.25 14.3375 19.173 14.5008 19.0373 14.6183L13.9957 18.9933C13.5584 19.3717 12.8333 19.09 12.8333 18.5417Z" fill="#1C4CAF" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_322_112">
                                                    <rect width="22" height="20" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </button>
                                </div>


                                <nav className="profile-nav">
                                    <div className={`nav-item ${activePanel === 'personal-info' ? 'active' : ''}`} onClick={() => setActivePanel('personal-info')} style={{ cursor: 'pointer' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                            <path d="M11.0001 10.8129C13.4925 10.8129 15.513 8.80282 15.513 6.32317C15.513 3.84352 13.4925 1.83337 11.0001 1.83337C8.50777 1.83337 6.4873 3.84352 6.4873 6.32317C6.4873 8.80282 8.50777 10.8129 11.0001 10.8129Z" fill="#1C4CAF" />
                                            <path d="M13.3505 12.6837H8.64966C5.92316 12.6837 3.66675 14.9287 3.66675 17.6412C3.66675 18.296 3.9488 18.8573 4.5129 19.1379C5.35905 19.6056 7.2394 20.1666 11.0001 20.1666C14.7608 20.1666 16.6411 19.6056 17.4872 19.1379C17.9573 18.8573 18.3334 18.296 18.3334 17.6412C18.3334 14.8351 16.077 12.6837 13.3505 12.6837Z" fill="#1C4CAF" />
                                        </svg>
                                        <span>{t('personalInformation')}</span>
                                    </div>
                                    <div className={`nav-item ${activePanel === 'change-email' ? 'active' : ''}`} onClick={() => setActivePanel('change-email')} style={{ cursor: 'pointer' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
                                            <path d="M21.8062 3.97351L15.134 10L21.8062 16.0266C21.9268 15.7974 22 15.544 22 15.2735V4.7266C22 4.45601 21.9268 4.20269 21.8062 3.97351Z" fill="#1C4CAF" />
                                            <path d="M20.0664 2.96875H1.93362C1.63597 2.96875 1.35732 3.03527 1.10522 3.14492L9.63293 10.8583C10.3869 11.5438 11.6131 11.5438 12.3671 10.8583L20.8948 3.14492C20.6427 3.03527 20.3641 2.96875 20.0664 2.96875Z" fill="#1C4CAF" />
                                            <path d="M0.193789 3.97351C0.0731758 4.20269 0 4.45601 0 4.7266V15.2735C0 15.5441 0.0731758 15.7974 0.193789 16.0266L6.86593 10L0.193789 3.97351Z" fill="#1C4CAF" />
                                            <path d="M14.2227 10.8286L13.2785 11.6869C12.0222 12.8291 9.97784 12.8291 8.72148 11.6869L7.77737 10.8286L1.10522 16.8551C1.35732 16.9648 1.63597 17.0313 1.93362 17.0313H20.0664C20.3641 17.0313 20.6427 16.9648 20.8948 16.8551L14.2227 10.8286Z" fill="#1C4CAF" />
                                        </svg>
                                        <span>Change Email Id</span>
                                    </div>
                                    {/* <div className="nav-item" href="#">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                            <path d="M15.125 19.5312C13.836 19.5312 12.7812 18.4844 12.7812 17.1875C12.7812 17.0938 12.7969 17.0078 12.8125 16.914H12.3672C11.0781 16.914 10.0234 15.8672 10.0234 14.5703C10.0234 13.8906 10.3281 13.2734 10.7969 12.8516V10.2734C10.7969 7.92189 12.2656 5.90625 14.3359 5.09372C14.7422 4.39062 15.4922 3.90625 16.3672 3.90625C16.961 3.90625 17.5078 4.1328 17.9141 4.5156C17.8515 2.87499 16.4922 1.5625 14.8359 1.5625H6.94532C5.2422 1.5625 3.85938 2.94528 3.85938 4.64845V20.3516C3.85938 22.0547 5.2422 23.4375 6.94532 23.4375H14.8359C16.539 23.4375 17.9219 22.0547 17.9219 20.3516V19.5C17.8125 19.5234 17.7031 19.5312 17.5859 19.5312H15.125ZM10.8828 4.6875H10.8906C11.3203 4.6875 11.6719 5.03907 11.6719 5.46875C11.6719 5.89843 11.3203 6.25 10.8906 6.25C10.4531 6.25 10.1016 5.89843 10.1016 5.46875C10.1016 5.03907 10.4453 4.6875 10.8828 4.6875Z" fill="#1C4CAF" />
                                            <path d="M20.3672 13.7926V10.2734C20.3672 8.33592 18.9844 6.71873 17.1485 6.35157L17.1448 6.35099V6.25C17.1448 5.81818 16.7954 5.46875 16.3636 5.46875C15.9317 5.46875 15.5823 5.81818 15.5823 6.25V6.3448C13.7483 6.70571 12.3594 8.33726 12.3594 10.2734V13.7925C11.9334 13.7991 11.5898 14.1437 11.5898 14.5714C11.5898 15.0032 11.9393 15.3526 12.3711 15.3526H20.3553C20.7871 15.3526 21.1365 15.0032 21.1365 14.5714C21.1365 14.1438 20.7931 13.7993 20.3672 13.7926Z" fill="#1C4CAF" />
                                            <path d="M17.5864 16.4062H15.1267C14.6949 16.4062 14.3455 16.7557 14.3455 17.1875C14.3455 17.6193 14.6949 17.9688 15.1267 17.9688H17.5864C18.0182 17.9688 18.3677 17.6193 18.3677 17.1875C18.3677 16.7557 18.0182 16.4062 17.5864 16.4062Z" fill="#1C4CAF" />
                                        </svg>
                                        <span>Push Notification</span>
                                    </div> */}
                                    <div className={`nav-item ${activePanel === 'change-password' ? 'active' : ''}`} onClick={() => setActivePanel('change-password')} style={{ cursor: 'pointer' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 20" fill="none">
                                            <path d="M10.9997 0.856201C8.22696 0.856201 5.97108 2.907 5.97108 5.42763V8.2866H5.34282C4.12955 8.2866 3.14282 9.1838 3.14282 10.2866V17.1437C3.14282 18.2465 4.12955 19.1437 5.34282 19.1437H16.6571C17.8701 19.1437 18.8571 18.2465 18.8571 17.1437V10.2866C18.8571 9.1838 17.8701 8.2866 16.6571 8.2866H16.0282V5.42763C16.0282 2.907 13.7723 0.856201 10.9997 0.856201ZM7.85679 5.42763C7.85679 3.85232 9.26681 2.57049 10.9997 2.57049C12.7325 2.57049 14.1425 3.85232 14.1425 5.42763V8.2866H7.85679V5.42763ZM7.54282 14.578C7.02105 14.578 6.59997 14.1952 6.59997 13.7209C6.59997 13.2465 7.02105 12.8637 7.54282 12.8637C8.06429 12.8637 8.48568 13.2465 8.48568 13.7209C8.48568 14.1952 8.06429 14.578 7.54282 14.578ZM11 14.578C10.4782 14.578 10.0571 14.1952 10.0571 13.7209C10.0571 13.2465 10.4782 12.8637 11 12.8637C11.5214 12.8637 11.9428 13.2465 11.9428 13.7209C11.9428 14.1952 11.5214 14.578 11 14.578ZM14.4571 14.578C13.9353 14.578 13.5143 14.1952 13.5143 13.7209C13.5143 13.2465 13.9353 12.8637 14.4571 12.8637C14.9786 12.8637 15.4 13.2465 15.4 13.7209C15.4 14.1952 14.9786 14.578 14.4571 14.578Z" fill="#1C4CAF" />
                                        </svg>
                                        <span>Change Password</span>
                                    </div>
                                    <div className="nav-item logout-btn" id="desktopLogoutBtn" onClick={() => openLogoutModal()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                            <path d="M5.71995 2.19995C3.77591 2.19995 2.19995 3.77591 2.19995 5.71995V10.12H11.5155L9.4977 8.10221C9.15406 7.75854 9.15406 7.20136 9.4977 6.85769C9.84134 6.51404 10.3986 6.51404 10.7422 6.85769L14.2616 10.3771L14.2679 10.3835C14.3495 10.4665 14.4112 10.5617 14.4532 10.6631C14.4959 10.7661 14.5196 10.879 14.5199 10.9973V11V11.0026C14.5192 11.2416 14.4232 11.4583 14.2679 11.6164L14.2616 11.6228L10.7422 15.1422C10.3986 15.4858 9.84134 15.4858 9.4977 15.1422C9.15406 14.7986 9.15406 14.2413 9.4977 13.8977L11.5155 11.88H2.19995V16.28C2.19995 18.224 3.77591 19.7999 5.71995 19.7999H16.28C18.224 19.7999 19.7999 18.224 19.7999 16.28V5.71995C19.7999 3.77591 18.224 2.19995 16.28 2.19995H5.71995Z" fill="#1C4CAF" />
                                        </svg>
                                        <span>Log Out</span>
                                    </div>
                                </nav>
                            </div>
                        </aside>

                        <section className="profile-content">
                            {/* <!-- Personal Information Panel --> */}
                            <div className="profile-panel" id="personal-info" style={{ display: activePanel === 'personal-info' ? 'block' : 'none' }}>
                                <h2 className="panel-title">{t('personalInformation')}</h2>

                                <div className="form-grid two">
                                    <div className="form-field">
                                        <label>{t('firstName')}</label>
                                        <input type="text" placeholder="Sumangal" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                    </div>
                                    <div className="form-field">
                                        <label>{t('lastName')}</label>
                                        <input type="text" placeholder="Basistha" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                    </div>
                                </div>

                                <h3 className="section-subtitle">{t('contactDetails')}</h3>
                                <div className="form-grid two">
                                    <div className="form-field">
                                        <label>{t('emailId')}</label>
                                        <input type="email" placeholder="Karen@gmail.com" value={email} disabled />
                                    </div>
                                    <div className="form-field">
                                        <label>{t('phoneNo')}</label>
                                        <input type="tel" placeholder="003248756897" value={phone} onChange={(e) => setPhone(e.target.value)} />
                                    </div>
                                </div>

                                <h3 className="section-subtitle">{t('addressDetails')}</h3>
                                <div className="form-grid three">
                                    <div className="form-field">
                                        <label htmlFor="edit-country" className='form-label mb-2'>{t('country')}</label>
                                        <select
                                            name="edit-countrys"
                                            id="edit-countrys"
                                            className="form-control"
                                            value={countryCode}
                                            onChange={(e) => {
                                                const selectedCode = e.target.value;
                                                setCountryCode(selectedCode);

                                                const selectedCountry = countryNameArray.find(
                                                    (country) => country.code === selectedCode
                                                );

                                                if (selectedCountry) {
                                                    setCountryName(selectedCountry.name);
                                                    handleInputChange('country', selectedCountry.name);
                                                }

                                                setStateNameArray([]);
                                                setCityNameArray([]);
                                                setStateCode('');
                                                setStateName('');
                                                setCityCode('');
                                                setCityName('');

                                                setTimeout(() => {
                                                    fetchStateAPI(selectedCode);
                                                }, 100);
                                            }}
                                        >
                                            <option value="">Select Country</option>
                                            {countryNameArray.map((country) => (
                                                <option key={country.code} value={country.code}>
                                                    {country.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-field">
                                        <label htmlFor="edit-state" className='form-label mb-2'>{t('state')}</label>
                                        <select
                                            name="edit-states"
                                            id="edit-states"
                                            className='form-control'
                                            value={stateCode}
                                            onChange={(e) => {
                                                const selectedCode = e.target.value;
                                                setStateCode(selectedCode);

                                                const selectedState = stateNameArray.find(
                                                    (states) => states.region_code === selectedCode
                                                );

                                                if (selectedState) {
                                                    setStateName(selectedState.region_name);
                                                    handleInputChange('state', selectedState.region_name);
                                                }

                                                setCityNameArray([]);
                                                setCityCode('');
                                                setCityName('');

                                                setTimeout(() => {
                                                    fetchCityAPI(selectedCode);
                                                }, 100);
                                            }}
                                        >
                                            <option value="">Select State</option>
                                            {stateNameArray.map((states) => (
                                                <option key={states.region_code} value={states.region_code}>
                                                    {states.region_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-field">
                                        <label htmlFor="edit-city" className='form-label mb-2'>{t('city')}</label>

                                        <select
                                            name="edit-citys"
                                            id="edit-citys"
                                            className='form-control'
                                            value={cityCode}
                                            onChange={(e) => {
                                                const selectedCode = e.target.value;
                                                setCityCode(selectedCode);

                                                const selectedCity = cityNameArray.find(
                                                    (citys) => citys.city_id === selectedCode
                                                );

                                                if (selectedCity) {
                                                    setCityName(selectedCity.city_name);
                                                    handleInputChange('city', selectedCity.city_name);
                                                }
                                            }}
                                        >
                                            <option value="">Select City</option>
                                            {cityNameArray.map((citys) => (
                                                <option key={citys.city_id} value={citys.city_id}>
                                                    {citys.city_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="profile-actions">
                                    <button className="btn-secondary">{t('discardChanges')}</button>
                                    <button
                                        className="btn-primary large"
                                        onClick={() => updateProfileAPI()}
                                        disabled={!isPersonalInfoChanged}
                                        style={{
                                            opacity: !isPersonalInfoChanged ? 0.6 : 1,
                                            cursor: !isPersonalInfoChanged ? 'not-allowed' : 'pointer'
                                        }}
                                    >
                                        {t('saveChanges')}
                                    </button>
                                </div>
                            </div>

                            {/* <!-- Change Email Id Panel --> */}
                            <div className="profile-panel" id="change-email" style={{ display: activePanel === 'change-email' ? 'block' : 'none' }}>
                                <h2 className="panel-title">{t('changeEmailId')}</h2>

                                <div className="form-grid two">
                                    <div className="form-field">
                                        <label htmlFor="currentEmail">Current Email Id <span style={{ color: 'red' }}>*</span></label>
                                        <input type="email" id="currentEmail" placeholder="Enter your current email" value={oldEmail} onChange={(e) => setOldEmail(e.target.value)} required />
                                    </div>
                                    <div className="form-field">
                                        <label htmlFor="newEmail">New Email Id <span style={{ color: 'red' }}>*</span></label>
                                        <input type="email" id="newEmail" placeholder="Enter your new email" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} required />
                                    </div>
                                </div>

                                <div className="form-grid two">
                                    <div className="form-field">
                                        <label htmlFor="confirmEmail">Confirm New Email Id <span style={{ color: 'red' }}>*</span></label>
                                        <input type="email" id="confirmEmail" placeholder="Confirm your new email" value={conEmail} onChange={(e) => setConEmail(e.target.value)} required />
                                    </div>
                                </div>

                                <div className="profile-actions">
                                    <button className="btn-secondary">{t('discardChanges')}</button>
                                    {/* <button className="btn-primary large" onClick={() => changeEmailAPI(oldEmail, newEmail, conEmail)}>{t('saveChanges')}</button> */}
                                    <button className="btn-primary large" onClick={() => setIsCodePopupOpen(true)}>{t('saveChanges')}</button>
                                </div>
                            </div>

                            {/* <!-- Change Password Panel --> */}
                            <div className="profile-panel" id="change-password" style={{ display: activePanel === 'change-password' ? 'block' : 'none' }}>
                                <h2 className="panel-title">{t('changePassword')}</h2>

                                <div className="form-grid two">
                                    <div className="form-field">
                                        <label htmlFor="currentPassword">Current Password <span style={{ color: 'red' }}>*</span></label>
                                        <input type="password" id="currentPassword" placeholder="Enter your current password" value={oldPass} onChange={(e) => setOldPass(e.target.value)} required />
                                    </div>
                                    <div className="form-field">
                                        <label htmlFor="newPassword">New Password <span style={{ color: 'red' }}>*</span></label>
                                        <input type="password" id="newPassword" placeholder="Enter your new password" value={newPass} onChange={(e) => setNewPass(e.target.value)} required />
                                    </div>
                                </div>

                                <div className="form-grid two">
                                    <div className="form-field">
                                        <label htmlFor="confirmPassword">Confirm New Password <span style={{ color: 'red' }}>*</span></label>
                                        <input type="password" id="confirmPassword" placeholder="Confirm your new password" value={conPass} onChange={(e) => setConPass(e.target.value)} required />
                                    </div>
                                </div>

                                <div className="profile-actions">
                                    <button className="btn-secondary">{t('discardChanges')}</button>
                                    <button className="btn-primary large" onClick={() => openChangePasswordModal()}>{t('saveChanges')}</button>
                                </div>
                            </div>
                        </section>
                    </section>
                </div>
            </main>


            {/* <!-- Profile Edit Modal --> */}
            {isEditModalOpen && (
                <div className="profile-edit-modal" id="profileEditModal">
                    <div className="profile-edit-modal-overlay" onClick={() => closeEditModal()}></div>
                    <div className="profile-edit-modal-content">
                        <div className="profile-edit-modal-header">
                            <h2 className="profile-edit-modal-title">Edit Profile</h2>
                            <button className="profile-edit-modal-close" id="profileEditModalClose" aria-label="Close" onClick={closeEditModal}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M18 6L6 18M6 6L18 18" stroke="#0E0E0E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>

                        <div className="profile-edit-modal-body">
                            {/* <!-- Profile Image Edit Section --> */}
                            <div className="profile-edit-image-section">
                                <div className="profile-edit-image-wrapper">
                                    <label htmlFor="profileImageUpload" style={{ cursor: 'pointer', display: 'block', width: '100%', height: '100%' }}>
                                        <img className="profile-edit-image" id="profileEditImage" src="https://images.unsplash.com/photo-1544006659-f0b21884ce1d?w=300&h=300&fit=crop&auto=format" alt="Profile" />
                                    </label>
                                    <input type="file" id="profileImageUpload" accept="image/*" style={{ display: 'none' }} />
                                </div>
                            </div>

                            <div className="form-grid two">
                                <div className="form-field">
                                    <label>First Name</label>
                                    <input type="text" id="editFirstName" placeholder="Sumangal" value="Sumangal" />
                                </div>
                                <div className="form-field">
                                    <label>Last Name</label>
                                    <input type="text" id="editLastName" placeholder="Basistha" value="Basistha" />
                                </div>
                            </div>

                            <h3 className="section-subtitle">CONTACT DETAILS</h3>
                            <div className="form-grid two">
                                <div className="form-field">
                                    <label>Email Id</label>
                                    <input type="email" id="editEmail" placeholder="Karen@gmail.com" value="Karen@gmail.com" />
                                </div>
                                <div className="form-field">
                                    <label>Phone No.</label>
                                    <input type="tel" id="editPhone" placeholder="003248756897" value="003248756897" />
                                </div>
                            </div>

                            <h3 className="section-subtitle">ADDRESS DETAILS</h3>
                            <div className="form-grid three">
                                <div className="form-field">
                                    <label>Country</label>
                                    <input type="text" id="editCountry" placeholder="Belgium" value="Belgium" />
                                </div>
                                <div className="form-field">
                                    <label>State</label>
                                    <input type="text" id="editState" placeholder="Brabant" value="Brabant" />
                                </div>
                                <div className="form-field">
                                    <label>City</label>
                                    <input type="text" id="editCity" placeholder="Anderlecht" value="Anderlecht" />
                                </div>
                            </div>
                        </div>

                        <div className="profile-edit-modal-actions">
                            <button className="btn-secondary" id="profileEditCancelBtn" onClick={closeEditModal}>Cancel </button>
                            <button className="btn-primary" id="profileEditSaveBtn">Save Changes</button>
                        </div>
                    </div>
                </div >
            )
            }

            {/* <!-- Language Preference Modal --> */}
            {isLanguageModalOpen && (
                <div className="language-modal" id="languageModal">
                    <div className="language-modal-overlay" onClick={closeLanguageModal}></div>
                    <LanguageSelector onClose={closeLanguageModal} />

                </div>
            )}

            {/* <!-- Switch Profile Modal --> */}
            {isSwitchProfileModalOpen && (
                <div className="switch-profile-modal" id="switchProfileModal">
                    <div className="switch-profile-modal-overlay" onClick={closeSwitchProfileModal}></div>
                    <div className="switch-profile-modal-content">
                        <div className="switch-profile-modal-header">
                            <h2 className="switch-profile-modal-title">Switch Profile</h2>
                            <button className="switch-profile-modal-close" id="switchProfileModalClose" aria-label="Close" onClick={closeSwitchProfileModal}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M18 6L6 18M6 6L18 18" stroke="#0E0E0E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>

                        <div className="switch-profile-modal-body">
                            <p className="switch-profile-description">Enter the agent code to switch profiles.</p>
                            <label className="switch-profile-label" htmlFor="switchAgentCode">Agent Code</label>
                            <div className="code-inputs" id="switchAgentCode" onPaste={handleSwitchCodePaste}>
                                {switchAgentKey.map((digit, index) => (
                                    <input
                                        key={index}
                                        ref={(el) => (switchCodeInputRefs.current[index] = el)}
                                        type="text"
                                        inputMode="numeric"
                                        maxLength="1"
                                        className="code-input"
                                        data-index={index}
                                        value={digit}
                                        onChange={(e) => handleSwitchCodeChange(index, e.target.value)}
                                        onKeyDown={(e) => handleSwitchCodeKeyDown(index, e)}
                                    />
                                ))}
                            </div>
                        </div>

                        <div className="switch-profile-modal-actions">
                            <button className="btn-secondary" id="switchProfileCancelBtn" onClick={closeSwitchProfileModal}>Cancel</button>
                            <button
                                className="btn-primary"
                                id="switchProfileSubmitBtn"
                                onClick={handleSwitchProfileSubmit}
                                disabled={switchAgentKey.join('').length !== 6}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}



            {/* <!-- Change Password Confirmation Modal --> */}
            {isChangePasswordModalOpen && (
                <div className="modal-section change-password-modal" id="changePasswordModal">
                    <div className="modal-overlay" onClick={() => closeChangePasswordModal()}></div>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h2 className="modal-title">Change Password</h2>

                        </div>

                        <div className="logout-modal-body">
                            <p className="logout-message">Are you sure! you want to change your password?</p>
                        </div>

                        <div className="logout-modal-actions">
                            <button className="cancel-btn" id="changePasswordNoBtn" onClick={() => closeChangePasswordModal()}>No</button>
                            <button className="save-btn" id="changePasswordYesBtn" onClick={() => handleChangePasswordConfirm()}>Yes</button>
                        </div>
                    </div>
                </div>
            )}

            {/* <!-- Change Email Sidebar --> */}
            {isChangeEmailSidebarOpen && (
                <>
                    <div className="sidebar-overlay" onClick={() => closeChangeEmailSidebar()}></div>
                    <section className="mobile-form-card change-email-modal sidebar">
                        <div className="sidebar-header">
                            <button className="sidebar-close mobile-form-back" aria-label="Close" onClick={() => closeChangeEmailSidebar()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24" fill="none">
                                    <path d="M11.668 23.2341C11.4486 23.2354 11.2312 23.1933 11.0281 23.1104C10.8251 23.0274 10.6404 22.9052 10.4847 22.7508L0.484654 12.7508C0.174236 12.4385 0 12.0161 0 11.5758C0 11.1355 0.174236 10.713 0.484654 10.4008L10.4847 0.400762C10.8035 0.127718 11.2136 -0.014959 11.6331 0.00124297C12.0525 0.0174449 12.4504 0.191331 12.7473 0.488156C13.0441 0.78498 13.218 1.18288 13.2342 1.60234C13.2504 2.0218 13.1077 2.43193 12.8347 2.75076L4.01799 11.5674L12.8347 20.3841C13.0687 20.6162 13.2286 20.9125 13.2943 21.2355C13.3599 21.5586 13.3283 21.8938 13.2034 22.1989C13.0786 22.5039 12.866 22.7651 12.5927 22.9494C12.3194 23.1336 11.9976 23.2327 11.668 23.2341Z" fill="black" />
                                </svg>
                            </button>
                            <h2 className="mobile-form-title">Change Email Id</h2>

                        </div>
                        <div className="mobile-form-fields">
                            <div className="form-grid two">
                                <div className="form-field">
                                    <label htmlFor="mobileCurrentEmail">Current Email Id <span style={{ color: 'red' }}>*</span></label>
                                    <input type="email" id="mobileCurrentEmail" placeholder="Enter your current email" value={oldEmail} onChange={(e) => setOldEmail(e.target.value)} required />
                                </div>
                                <div className="form-field">
                                    <label htmlFor="mobileNewEmail">New Email Id <span style={{ color: 'red' }}>*</span></label>
                                    <input type="email" id="mobileNewEmail" placeholder="Enter your new email" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} required />
                                </div>
                            </div>

                            <div className="form-grid one">
                                <div className="form-field">
                                    <label htmlFor="mobileConfirmEmail">Confirm New Email Id <span style={{ color: 'red' }}>*</span></label>
                                    <input type="email" id="mobileConfirmEmail" placeholder="Confirm your new email" value={conEmail} onChange={(e) => setConEmail(e.target.value)} required />
                                </div>
                            </div>

                            <div className="mobile-form-actions">
                                <button type="button" className="btn-secondary" onClick={closeChangeEmailSidebar}>Discard Changes</button>
                                <button type="submit" className="btn-primary large" onClick={() => changeEmailAPI(oldEmail, newEmail, conEmail)}>Save Changes</button>
                            </div>
                        </div>
                    </section>
                </>
            )}

            {/* <!-- Change Password Sidebar --> */}

            {isChangePasswordSidebarOpen && (
                <>
                    <div className="sidebar-overlay" onClick={() => closeChangePasswordSidebar()}></div>
                    <section className="mobile-form-card change-password-modal sidebar">
                        <div className="sidebar-header">
                            <button className="sidebar-close mobile-form-back" aria-label="Close" onClick={() => closeChangePasswordSidebar()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24" fill="none">
                                    <path d="M11.668 23.2341C11.4486 23.2354 11.2312 23.1933 11.0281 23.1104C10.8251 23.0274 10.6404 22.9052 10.4847 22.7508L0.484654 12.7508C0.174236 12.4385 0 12.0161 0 11.5758C0 11.1355 0.174236 10.713 0.484654 10.4008L10.4847 0.400762C10.8035 0.127718 11.2136 -0.014959 11.6331 0.00124297C12.0525 0.0174449 12.4504 0.191331 12.7473 0.488156C13.0441 0.78498 13.218 1.18288 13.2342 1.60234C13.2504 2.0218 13.1077 2.43193 12.8347 2.75076L4.01799 11.5674L12.8347 20.3841C13.0687 20.6162 13.2286 20.9125 13.2943 21.2355C13.3599 21.5586 13.3283 21.8938 13.2034 22.1989C13.0786 22.5039 12.866 22.7651 12.5927 22.9494C12.3194 23.1336 11.9976 23.2327 11.668 23.2341Z" fill="black" />
                                </svg>
                            </button>
                            <h2 className="mobile-form-title">Change Password</h2>

                        </div>
                        <div className="mobile-form-fields">
                            <div className="form-grid two">
                                <div className="form-field">
                                    <label htmlFor="currentPassword">Current Password <span style={{ color: 'red' }}>*</span></label>
                                    <input type="password" id="currentPassword" placeholder="Enter your current password" value={oldPass} onChange={(e) => setOldPass(e.target.value)} required />
                                </div>
                                <div className="form-field">
                                    <label for="newPassword">New Password <span style={{ color: 'red' }}>*</span></label>
                                    <input type="password" id="newPassword" placeholder="Enter your new password" value={newPass} onChange={(e) => setNewPass(e.target.value)} required />
                                </div>
                            </div>

                            <div className="form-grid one">
                                <div className="form-field">
                                    <label htmlFor="confirmPassword">Confirm New Password <span style={{ color: 'red' }}>*</span></label>
                                    <input type="password" id="confirmPassword" placeholder="Confirm your new password" value={conPass} onChange={(e) => setConPass(e.target.value)} required />
                                </div>
                            </div>

                            <div className="mobile-form-actions">
                                <button type="button" className="btn-secondary" onClick={() => closeChangePasswordSidebar()}>{t('discardChanges')}</button>
                                <button type="submit" className="btn-primary large" onClick={() => openChangePasswordModal()}>{t('save')}</button>
                            </div>
                        </div>
                    </section>
                </>
            )}

            {/* Image Cropper Modal */}
            {isCropperOpen && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    zIndex: 10000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px'
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '20px',
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '20px',
                        width: '100%',
                        maxWidth: '600px'
                    }}>
                        <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>Crop Image</h3>
                        <div style={{
                            position: 'relative',
                            width: '100%',
                            height: '400px',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '8px',
                            overflow: 'hidden'
                        }}>
                            <Cropper
                                image={cropperImageSrc}
                                crop={crop}
                                zoom={zoom}
                                aspect={1}
                                onCropChange={setCrop}
                                onZoomChange={setZoom}
                                onCropComplete={onCropComplete}
                            />
                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '15px'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                            }}>
                                <label style={{ fontSize: '14px', fontWeight: '500', minWidth: '60px' }}>Zoom:</label>
                                <input
                                    type="range"
                                    value={zoom}
                                    min={1}
                                    max={3}
                                    step={0.1}
                                    onChange={(e) => setZoom(parseFloat(e.target.value))}
                                    style={{
                                        flex: 1,
                                        height: '6px',
                                        borderRadius: '3px',
                                        background: '#ddd',
                                        outline: 'none'
                                    }}
                                />
                                <span style={{ fontSize: '14px', minWidth: '40px', textAlign: 'right' }}>
                                    {zoom.toFixed(1)}x
                                </span>
                            </div>
                            <div style={{
                                display: 'flex',
                                gap: '10px',
                                justifyContent: 'flex-end'
                            }}>
                                <button
                                    onClick={handleCropCancel}
                                    style={{
                                        padding: '10px 20px',
                                        backgroundColor: '#f5f5f5',
                                        border: '1px solid #ddd',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        fontWeight: '500'
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleCropSave}
                                    style={{
                                        padding: '10px 20px',
                                        backgroundColor: '#1C4CAF',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        fontWeight: '500'
                                    }}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Upload Loader */}
            {isUploadingImage && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '30px',
                        borderRadius: '12px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '20px'
                    }}>
                        <div style={{
                            width: '50px',
                            height: '50px',
                            border: '4px solid #f3f3f3',
                            borderTop: '4px solid #1C4CAF',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite'
                        }} />
                        <p style={{ margin: 0, fontSize: '16px', fontWeight: '500' }}>Uploading image...</p>
                    </div>
                </div>
            )}

            {/* Six Digit Code Popup */}
            {isCodePopupOpen && (
                <div className={`code-popup-modal ${isCodePopupOpen ? 'is-open' : 'is-open'}`}>
                    <div className="code-popup-modal-overlay" onClick={handleCancelCode}></div>
                    <div className="code-popup-modal-content">
                        <div className="code-popup-modal-header">
                            <h3 className="code-popup-modal-title">Enter Verification Code</h3>
                        </div>
                        <div className="code-popup-modal-body">
                            <p className="code-popup-description">Please enter the 6-digit code sent to your email</p>
                            <div className="code-input-container">
                                {agentKey.map((digit, index) => (
                                    <input
                                        key={index}
                                        ref={(el) => (codeInputRefs.current[index] = el)}
                                        type="text"
                                        inputMode="numeric"
                                        maxLength="1"
                                        className="code-input"
                                        value={digit}
                                        onChange={(e) => handleCodeChange(index, e.target.value)}
                                        onKeyDown={(e) => handleCodeKeyDown(index, e)}
                                        onPaste={handleCodePaste}
                                        autoComplete="off"
                                    />
                                ))}
                            </div>
                        </div>
                        <div className="code-popup-modal-actions">
                            <button className="btn btn-secondary" onClick={handleCancelCode}>
                                Cancel
                            </button>
                            <button
                                className="btn save-btn"
                                onClick={handleSubmitCode}
                                disabled={agentKey.join('').length !== 6}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>

            {isLogoutModalOpen && (
                <>
                    <div
                        className="modal-overlay"
                        onClick={closeLogoutModal}

                    />
                    <div
                        className="logout-modal"

                    >
                        <h3 style={{
                            margin: '0 0 15px 0',
                            fontSize: '20px',
                            fontWeight: '600',
                            color: '#fff'
                        }}>
                            {t('confirmLogout') || 'Confirm Logout'}
                        </h3>
                        <p style={{
                            margin: '0 0 25px 0',
                            fontSize: '16px',
                            color: '#fff',
                            lineHeight: '1.5'
                        }}>
                            {t('areYouSureYouWantToLogout') || 'Are you sure you want to logout?'}
                        </p>
                        <div className='btn-sec'>
                            <button className='cancel-btn custom-btn'
                                onClick={closeLogoutModal}

                            >
                                {t('no') || 'No'}
                            </button>
                            <button className='save-btn custom-btn'
                                onClick={logout}

                            >
                                {t('yes') || 'Yes'}
                            </button>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}